<template>
  <div>
    <v-btn icon small @click="onLikeToggle">
      <v-icon
        :size="size === 'large' ? '22' : '18'"
        :color="liked ? 'red' : '#828282'"
      >
        {{ liked ? "fas fa-heart" : "fal fa-heart" }}
      </v-icon>
      <!-- <v-icon :size="size === 'large' ? '22' : '18'" color="red">fas fa-heart</v-icon> -->
    </v-btn>
    <span
      :class="[size === 'large' ? 'text-md-subtitle-2 body-2' : 'caption']"
      class="grey--text"
    >
      {{ totalLike }} <translate>Likes</translate>
    </span>
  </div>
</template>
<script>
export default {
  name: "ButtonLike",
  components: {  },
  props: {
    size: {},
    count: {
      type: Number,
      default: 0,
    },
    isLiked: {
      type: Boolean,
      default: false,
    },
    entityId: {},
    parent: {},
    type: { type: String, default: "post" },
    oneway: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      liked: false,
      totalLike: 0,
    };
  },
  watch: {
    isLiked: {
      immediate: true,
      handler(val) {
        this.liked = val;
      },
    },
    count: {
      immediate: true,
      handler(val) {
        this.totalLike = parseInt(val || 0);
      },
    },
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    async onLikeToggle() {
      if (!this.token) {
        const toggle = await this.$store.state.toggle.dialogConfirm.open(
          this.$gettext("Warning"),
          this.$gettext('You need to login'),
          { color: "warning" }
        );
        if (!toggle) return
        this.$router.push({name: 'login'})
      }

      let nameDispatch = this.liked ? "post/setUnLike" : "post/setLike";
      this.$store.dispatch(nameDispatch, {
        entityId: this.entityId,
        entityName: this.type,
      });

      let totalLike = this.liked ? --this.totalLike : ++this.totalLike;
      let item = {
        id: this.entityId,
        isLiked: !this.liked,
        totalLike: totalLike,
        parent: this.parent,
      };
      this.$emit("onLike", item);

      if (!this.oneway) {
        this.totalLike = totalLike;
        this.liked = !this.liked;
      }
    },
  },
};
</script>
